import React from 'react';
import styled from 'styled-components';
import { theme } from 'theme/MainTheme';
import Help from 'components/atoms/Help/Help';
import i18next from 'i18next';
import { languages } from 'languages';

const WrapperLangswitcher = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  align-items: center;
  top: 0;
  width: 100%;
  height: 56px;
  text-transform: uppercase;
  font-weight: ${theme.bold};
  font-size: ${theme.fontSize.xs};
  color: ${theme.primary};
  &.drawer {
    height: 100%;
    display: flex;
    align-items: center;
    a {
      color: ${theme.white};
    }
  }
`;

const LangList = styled.ul`
  list-style: none;
  display: flex;
  li {
    padding-right: 1rem;
    a {
      text-decoration: none;
      color: ${theme.primary};
    }
  }
`;

const LangswitcherWithHelp = ({ linkColor, btn }) => (
  <WrapperLangswitcher className={linkColor}>
    <LangList>
      {languages.map((item) => (
        <li key={item.country_code}>
          <a href="#" onClick={() => i18next.changeLanguage(item.code)}>
            {item.display_code}
          </a>
        </li>
      ))}
    </LangList>
    <Help btn={btn} />
  </WrapperLangswitcher>
);

export default LangswitcherWithHelp;
